import Reveal from "./Reveal";

export const SectionHeading = ({ overline, title, subtitle, align = "left", className = "" }) => (
  <Reveal className={`${align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} ${className}`}>
    {overline && (
      <span className="text-xs font-bold tracking-[0.22em] uppercase text-royal mb-4 block">
        {overline}
      </span>
    )}
    <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-navy-900 leading-[1.05]">
      {title}
    </h2>
    {subtitle && <p className="mt-5 text-base md:text-lg text-slate-500 leading-relaxed">{subtitle}</p>}
  </Reveal>
);

export default SectionHeading;
